import { render, staticRenderFns } from "./QuestionTypeVideo.vue?vue&type=template&id=aee909f6"
import script from "./QuestionTypeVideo.vue?vue&type=script&lang=js"
export * from "./QuestionTypeVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports